export default __webpack_public_path__ + "static/banl-logo-circle-cb60fef1212858f318328b695969ed9c.png";